import {
  GETVOUCHERMAPPINGLIST_SUCCESS,
  GETVOUCHERMAPPINGLIST_FAILED,
  RESET_GETVOUCHERMAPPINGLIST,
  LOADING_GETVOUCHERMAPPINGLIST,
  NETWORK_ERROR_GETVOUCHERMAPPINGLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVOUCHERMAPPINGLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVOUCHERMAPPINGLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVOUCHERMAPPINGLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVOUCHERMAPPINGLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVOUCHERMAPPINGLIST:
      return (state = initialState);
    default:
      return state;
  }
};
